import colors from '@constants/colors';

function ReusableCupDefault() {
  return (
        <svg width="53" height="52" viewBox="0 0 53 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="26.75" cy="26" r="25.5" fill={colors.gray1} stroke="#0D0F11"/>
            <path
                d="M22.6389 32.75H24.3677H26.0213H27.7501C30.5728 32.75 32.8612 30.4617 32.8612 27.6389V26.3611V22.5278C32.8612 21.8221 32.2891 21.25 31.5834 21.25H22.6389H18.8056C18.0999 21.25 17.5278 21.8221 17.5278 22.5278V26.3611V27.6389C17.5278 30.4617 19.8162 32.75 22.6389 32.75Z"
                fill="white" stroke="#0D0F11" strokeWidth="2"/>
            <path
                d="M33.679 22.5278H35.9278C37.0569 22.5278 37.9722 23.4432 37.9722 24.5723V25.5945C37.9722 26.7236 37.0569 27.6389 35.9278 27.6389H32.8611"
                stroke="#0D0F11" strokeWidth="2" strokeLinecap="round"/>
        </svg>
  );
}

export default ReusableCupDefault;
